import { AddStock } from '../../pages';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import { InventoryController } from '../../controllers';
import constant from '../../utils/constant';
import { MimaToastUtil } from '../../components';
import { inventoryStore, userStore } from '../../stores';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const AddStockContainer = ({ closeModal, goBack, setShowSurvey }) => {
	const [loading, setLoading] = useState(false);
	const [varyType, setVaryType] = useState(false)

	const { needFeedback } = useGetAllActiveReviews(constant.FEEDBACK.STOCKADDSTOCK);

	useEffect(()=>{
		if (inventoryStore?.selectedProduct?.type === "Product") {
			setVaryType(true)
		}
	}, [])

	const onSelect = async (values) => {
		const amount = values.sellingPriceUSD;
		await InventoryController.getRates('USD', amount);
	};

	const validationSchema = () => {
		return yup.object({
			title: yup.string().required('Title is required'),
			quantity: yup.number()
			.when('validCondition', {
				is: true,
				then: (schema) => schema.min(0.1, 'Minimum should be 0.1').required('quantity is required'),
				otherwise: (schema) => schema.optional()
			}),
			sellingPrice: yup.number().min(1, 'Minimum should be 1').required('Selling Price is required'),
			costPrice: yup.number().min(0, 'Minimum should be 0').required('Cost Price is required'),
			currencyCode: yup.string().required('Select Currency'),
			// variations: yup.array(
			// 	yup.object({
			// 		type: yup.string().required('Type is required'),
			// 		value: yup.string().required('Value is required'),
			// 	})
			// ),
		});
	};
	const onSubmit = async payload => {
		setLoading(true);

		if (inventoryStore?.selectedProduct?.type === "Service") {
			payload.quantity = 100000
		}
		if (payload.variations.length === 1 && payload.variations[0].value === "" && payload.variations[0].type === "") {
			payload.variations = []
		}
		delete payload.validCondition

		const { status, errorMessage } = await InventoryController.createStock(payload, inventoryStore.selectedProduct?._id);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			 closeModal();
			 if (needFeedback._id) {
				setShowSurvey(true)
				userStore.setReviewId(needFeedback._id)
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<AddStock
			closeModal={closeModal}
			goBack={goBack}
			loading={loading}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			varyType={varyType}
			setVaryType={setVaryType}
			onSelect={onSelect}
		/>
	);
};

export default observer(AddStockContainer);
